import React from "react";
import { useStatisticsPeriodStore } from "@/store/statisticsPeriodStore";
import { formatRubles } from "@/utils/helpers";
import { useDashboardStore } from "@/store/dashboardStore";
import cls from "./styles.module.scss";

export const EarningsHero = () => {
  const mode = useStatisticsPeriodStore((s) => s.mode);
  const dashboardInfo = useDashboardStore((s) => s.dashboardInfo);
  const isCompletionMode = mode === "completion";

  if (!dashboardInfo) return null;

  return (
    <>
      <div className={cls.hero}>
        <div className={cls.label}>
          {isCompletionMode ? "Начислено за период" : "Принесли эти рефералы"}
        </div>
        <div className={cls.value}>
          {Number(dashboardInfo?.summary.accrued.total).toLocaleString("ru-RU")}
          <small>₽</small>
        </div>

        <div className={cls.footnote}>
          Ещё{" "}
          <b>{formatRubles(dashboardInfo?.summary.potential.known_amount)}</b>{" "}
          {isCompletionMode
            ? "можно получить с рефералов, у которых не закончились 28 дней на выполнение целей."
            : "принесут те из них, у кого не закончились 28 дней на выполнение целей."}
        </div>
      </div>
    </>
  );
};
